import { Edit01Icon } from '@langchain/untitled-ui-icons';

import { useState } from 'react';

import { DashboardCrudModal } from '@/Pages/Dashboards/components/DashboardCrudModal';
import useToast from '@/components/Toast/useToast';
import { Tooltip } from '@/design-system';
import { useUpdateCustomChartsSectionMutation } from '@/hooks/useSwr';
import { CustomChartsSectionSchema } from '@/types/schema';

import { DASHBOARD_HEADER_BUTTON_STYLE } from '../constants';

export const EditDashboardButton = ({
  dashboard,
  mutateDashboards,
}: {
  dashboard: CustomChartsSectionSchema;
  mutateDashboards: () => void;
}) => {
  const [isEditOpen, setEditOpen] = useState(false);
  const { createToast } = useToast();
  const updateSection = useUpdateCustomChartsSectionMutation(dashboard.id, {
    onSuccess: () => {
      mutateDashboards();
      createToast({
        title: 'Success',
        description: 'Dashboard updated successfully',
      });
    },
    onError: (error) => {
      createToast({
        title: 'Error updating dashboard',
        description: error.message,
        type: 'error',
      });
    },
  });
  return (
    <>
      <Tooltip title={'Edit Dashboard'} tooltipClassName="p-0">
        <button
          type="button"
          className={DASHBOARD_HEADER_BUTTON_STYLE}
          onClick={() => setEditOpen(true)}
        >
          <Edit01Icon className="size-4" />
        </button>
      </Tooltip>
      <DashboardCrudModal
        isOpen={isEditOpen}
        doClose={() => setEditOpen(false)}
        initialData={dashboard}
        onSubmit={(data) => {
          if ('id' in data) {
            // data.index is deprecated but not removed as db column yet.
            delete data.index;
            updateSection.trigger({ json: data });
          } else {
            // this should never happen
            createToast({
              title: 'Error',
              description: 'Dashboard not found',
              type: 'error',
            });
          }
        }}
      />
    </>
  );
};
